export default "__VITE_ASSET__CdYVzc2P__"